var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6581 13.3806C39.3472 4.17477 30.0112 -1.41465 20.8054 0.896226C13.6112 2.70218 8.38747 8.91996 7.84925 16.3177C2.74112 17.1601 -0.716999 21.9839 0.12539 27.092C0.874233 31.6332 4.80915 34.9589 9.41158 34.9406H17.2232V31.816H9.41158C5.9602 31.816 3.16226 29.0181 3.16226 25.5667C3.16226 22.1153 5.9602 19.3174 9.41158 19.3174C10.2745 19.3174 10.9739 18.6179 10.9739 17.755C10.9661 9.98937 17.2552 3.68772 25.0208 3.68C31.7431 3.67327 37.5299 8.42568 38.8302 15.021C38.9586 15.6795 39.4931 16.1825 40.1582 16.2708C44.4294 16.879 47.3987 20.8346 46.7906 25.1057C46.2445 28.941 42.9698 31.7967 39.0958 31.816H32.8465V34.9406H39.0958C45.1358 34.9224 50.0173 30.0112 49.9989 23.9712C49.9837 18.9435 46.5423 14.5737 41.6581 13.3806Z",
    fill: "#105EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9261 19.7708L17.6768 26.0201L19.8796 28.223L23.473 24.6452V39.628H26.5977V24.6452L30.1754 28.223L32.3783 26.0201L26.129 19.7708C25.5196 19.165 24.5355 19.165 23.9261 19.7708Z",
    fill: "#105EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.9369bad41373f3bfb56c0946c8288520.svg";
export { ForwardRef as ReactComponent };